import app from 'flarum/common/app';
app.initializers.add('glowingblue-search-common', () => {});